import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private messageSource = new BehaviorSubject<any>(null);
  currentMessage$ = this.messageSource.asObservable();

  sendMessage(message: any): void {
    this.messageSource.next(message);
  }

  clearMessage(): void {
    this.messageSource.next(null);
  }
}
